import {PageTransformFn} from '@/src/core/domain/page/functions/types'
import {ServerPageData} from '@/src/core/domain/entities/page/page-data'
import {PageType} from '@/src/core/domain/entities/page'
import React from 'react'
import {FunctionalTestingPageContent} from '@/src/(pages)/testing/ui/functional-testing-screen'
import {FunctionalTestingContent} from '@/src/(pages)/testing/suspense/func-testing-content'
import {parseHTMLContent} from '@/src/shared/modules/html-snippets/parse'

export const funcTestingTransform: PageTransformFn<FunctionalTestingPageContent> = async function (
  data: ServerPageData<FunctionalTestingPageContent>,
  session,
  isMobile,
) {
  if (isMobile && data.type === PageType.FunctionalTesting) {
    // @ts-ignore TODO: исправить
    data.topContent = data.content.top_block && (
      <FunctionalTestingContent promise={parseHTMLContent(data.content.top_block)} />
    )

    // @ts-ignore TODO: исправить
    data.bottomContent = data.content.bottom_block && (
      <FunctionalTestingContent promise={parseHTMLContent(data.content.bottom_block)} />
    )
  }
  return data
}
